import { createContext, Dispatch, SetStateAction, useEffect, useState } from 'react'
import qs from 'qs'
import { ID, QueryResponseContextProps, QuerySingleResponseContextProps, QueryState } from './custom-models'
import { useAuth } from '../../../app/modules/auth'

function createResponseContext<T>(initialState: QueryResponseContextProps<T>) {
  return createContext(initialState)
}

function createSingleResponseContext<T>(initialState: QuerySingleResponseContextProps<T>) {
  return createContext(initialState)
}

function isNotEmpty(obj: unknown) {
  return obj !== undefined && obj !== null && obj !== ''
}

// Example: page=1&items_per_page=10&sort=id&order=desc&search=a&filter_name=a&filter_online=false
function stringifyRequestQuery(state: QueryState): string {
  const pagination = qs.stringify(state, { filter: ['page', 'limit'], skipNulls: true })
  const sort = qs.stringify(state, { filter: ['sort', 'order'], skipNulls: true })
  const search = isNotEmpty(state.search)
  // const filter_inventory = (state?.filter_inventory) 
    ? qs.stringify(state, { filter: ['search'], skipNulls: true })
    : ''

  const filter = state.filter
    ? Object.entries(state.filter as Object)
      .filter((obj) => isNotEmpty(obj[1]))
      .map((obj) => {
        return `filter_${obj[0]}=${obj[1]}`
      })
      .join('&')
    : ''

  return [pagination, sort, search, filter]
    .filter((f) => f)
    .join('&')
    .toLowerCase()
}

function parseRequestQuery(query: string): QueryState {
  const cache: unknown = qs.parse(query)
  return cache as QueryState
}

function calculatedGroupingIsDisabled<T>(isLoading: boolean, data: Array<T> | undefined): boolean {
  if (isLoading) {
    return true
  }

  return !data || !data.length
}


function calculateIsAllDataSelected(data: any| undefined, selected: Array<ID>,manageUSer:any,currentUser?:any): any {
  if (!data) {
    return false
  }
  if(manageUSer=="manageUSer"){
    return data.length > 0 && (data.length-1) === selected.length  
  }else if(manageUSer=="manageRoles"){
    return data.length > 0 && (data.length-3) === selected.length  
  }else if(manageUSer=="usermange_role"){
     const check = data?.some(i=>i?.id === currentUser?.id)
    //  console.log("checkvnjsdjsd",check)
     if(!check){
      return data.length > 0 &&  (data.length) === selected.length  
     }else{
       return data.length > 0 &&  (data.length-1) === selected.length  
     }
  }
  else{
    return data.length > 0 && data.length === selected.length
  }
  
}


function groupingOnSelect(
  id: ID,
  selected: Array<ID>,
  setSelected: Dispatch<SetStateAction<Array<ID>>>
) {
  if (!id ) {
    return
  }

  if (selected.includes(id)) {
    setSelected(selected.filter((itemId) => itemId !== id))
  } else {
    const updatedSelected = [...selected]
    updatedSelected.push(id)
    setSelected(updatedSelected)
  }
}

function groupingOnSelectAll<T>(isAllSelected: boolean,setSelected: Dispatch<SetStateAction<Array<ID>>>,data?: Array<T & { id?: ID }>,manageUSer?:String, currentUser?:any) {


  if (isAllSelected) {
    setSelected([])
    return
  }

  if (!data || !data.length) {
    return
  }
  if(manageUSer=="manageUSer"){
    setSelected(data.filter((item) => item.id!=1).map((item) => item.id))
  }else if(manageUSer=="manageRoles"){
    setSelected(data.filter((item) => item.id!=1 && item.id!=2 && item.id!=3).map((item) => item.id))
  }
  
  else if(manageUSer === "usermange_role"){
   setSelected(data.filter((item) => item.id !== currentUser?.id).map((item) => item.id))
  }
  else{
    setSelected(data.filter((item) => item.id).map((item) => item.id))
  }
  
}

// Hook
function useDebounce(value: string | undefined, delay: number) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler)
      }
    },
    [value, delay] // Only re-call effect if value or delay changes
  )
  return debouncedValue
}

export {
  createResponseContext,
  createSingleResponseContext,
  stringifyRequestQuery,
  parseRequestQuery,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  groupingOnSelectAll,
  useDebounce,
  isNotEmpty,
}
